import { ProjectId } from 'api/models';
import { Task } from 'api/tasks';
import { ActorName } from 'data/core';
import { useProjectDetailWebsocket } from './use-project-detail-websocket';
import { useProjectMembersWebsocket } from './use-project-members-websocket';
import { useProjectPhaseWebsocket } from './use-project-phase-websocket';
import { useProjectPlaceholderWebsocket } from './use-project-placeholder-websocket';
import { useProjectSpaceWebsocket } from './use-project-space-websocket';
import { useProjectTaskWebsocket } from './use-project-task-websocket';

export const useProjectWebsocket = (
  projectId: ProjectId,
  options?: {
    onFetchTaskSuccess?: (task: Task | undefined) => void;
    actorName?: ActorName;
    skipStoreUpdate?: boolean;
  },
): void => {
  useProjectDetailWebsocket(projectId);
  useProjectMembersWebsocket(projectId);
  useProjectPhaseWebsocket(projectId);
  useProjectSpaceWebsocket(projectId);
  useProjectTaskWebsocket(projectId, options);
  useProjectPlaceholderWebsocket(projectId);
};
